// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","disclaimerHeadline":"wizardDataProtectionDisclaimer_disclaimerHeadline__OnWT2"};